import styled from 'styled-components';
import { Icon } from '@fnacdarty/back-office-ui';

export const StyledInputSearch = styled.div`
	margin-top: 10px;
	margin-bottom: 10px;
	width: 200px;
`;

export const StyledError = styled.p`
	width: 100%;
	color: ${({ theme }) => theme.colors.error};
	text-align: center;
`;

export const StyledContainerList = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	max-width: 1350px;
	width: 100%;
`;

export const StyledHeader = styled.header`
	display: flex;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 30px;
	max-width: 945px;
	margin: 5px;
	padding: 5px;
`;

export const StyledActivityList = styled.div`
	height: calc(100vh - 200px);
	overflow-y: auto;
	width: auto;
	max-width: 945px;
	margin: 0px 5px auto;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		width: 100%;
		overflow-x: hidden;
	}
	&::-webkit-scrollbar {
		width: 10px;
	}
	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}
	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.colors.primary};
		border-radius: 10px;
		border: 2px solid #f1f1f1;
	}
	&::-webkit-scrollbar-thumb:hover {
		background-color: ${({ theme }) => theme.colors.primaryLight};
	}
`;
export const DivError = styled.div`
	background-color: #fce4e4;
	border: 1px solid #fcc2c3;
	float: left;
	padding: 20px 30px;
	width: 85%;
	text-align: center;
	margin-left: 10px;
`;

export const SpanError = styled.div`
	color: #cc0033;
	font-family: Helvetica, Arial, sans-serif;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;
	text-shadow: 1px 1px rgba(250, 250, 250, 0.3);
`;

export const StyledSearchIcon = styled(Icon)`
	position: absolute;
	top: 1.5em;
	right: 3em;
	transform: translateY(-50%);
	color: ${({ theme }) => theme.colors.text};
`;
